module.exports = __webpack_public_path__ + "img/stickers-extrait-KBIS.38ba3146.jpg";